// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".richtext-editor-light {\n    height: calc(100% - 20px);\n    overflow-y: scroll;\n    color: #222222;\n    font-family: 'Open Sans';\n    padding: 10px;\n    z-index: 0;\n}\n\n.richtext-editor-dark {\n    height: calc(100% - 20px);\n    overflow-y: scroll;\n    color: #D3CFC9;\n    font-family: 'Open Sans';\n    padding: 10px;\n    z-index: 0;\n}\n", ""]);
// Exports
module.exports = exports;
